import {Component} from '@angular/core';

@Component({
  selector: 'geec-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {

}
